(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-editorial-article"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mp-article]').forEach((article) => {
    const body = article.querySelector('[data-mp-article-body]');
    const toc = article.querySelector('[data-mp-article-toc]');
    if (!body || !toc) return;
    const headings = [...body.querySelectorAll('h2')];
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `article-section-${index + 1}`;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      toc.appendChild(link);
    });
    if (!headings.length) toc.hidden = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-home-video-feature"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mp-home-video]').forEach((frame) => {
    const video = frame.querySelector('video');
    const button = frame.querySelector('[data-mp-home-video-toggle]');
    const icon = frame.querySelector('[data-mp-home-video-icon]');
    const section = frame.closest('.mp-home-video-feature');
    const shopifySection = frame.closest('.shopify-section');
    const backdrop = section?.querySelector('[data-mp-home-video-backdrop]');
    const closeButton = frame.querySelector('[data-mp-home-video-close]');
    if (!video || !button || !icon || !section || !closeButton) return;

    video.pause();
    video.muted = true;
    video.volume = 1;

    const pauseQuietly = () => {
      video.pause();
      video.muted = true;
      sync();
    };

    const playWithSound = () => {
      document.dispatchEvent(new CustomEvent('mp:video-play-request', { detail: { video } }));
      video.muted = false;
      video.volume = 1;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          video.muted = true;
          sync();
        });
      }
      sync();
    };

    const setImmersive = (open) => {
      section.classList.toggle('is-immersive', open);
      shopifySection?.classList.toggle('mp-home-video-active-section', open);
      document.body.classList.toggle('mp-home-video-focus', open);
      frame.setAttribute('aria-label', open ? 'Close immersive video' : 'Play video with sound');
      frame.setAttribute('aria-pressed', open ? 'true' : 'false');
    };

    const sync = () => {
      const paused = video.paused || video.muted;
      button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      button.setAttribute('aria-pressed', paused ? 'true' : 'false');
      icon.textContent = paused ? '▶' : 'Ⅱ';
    };

    frame.addEventListener('click', (event) => {
      if (event.target.closest('button')) return;
      if (video.paused || video.muted) playWithSound();
      else pauseQuietly();
    });

    frame.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (video.paused || video.muted) playWithSound();
        else pauseQuietly();
      }
    });

    frame.addEventListener('mouseenter', playWithSound);
    frame.addEventListener('mouseleave', pauseQuietly);
    document.addEventListener('mp:video-play-request', (event) => {
      if (event.detail?.video !== video) pauseQuietly();
    });

    backdrop?.addEventListener('click', () => {
      pauseQuietly();
      setImmersive(false);
    });
    closeButton.addEventListener('click', (event) => {
      event.stopPropagation();
      pauseQuietly();
      setImmersive(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && section.classList.contains('is-immersive')) {
        pauseQuietly();
        setImmersive(false);
      }
    });

    button.addEventListener('click', (event) => {
      event.stopPropagation();
      if (video.paused || video.muted) playWithSound();
      else pauseQuietly();
    });

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-loop-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mp-loop-video]').forEach((frame) => {
    const video = frame.querySelector('video');
    const button = frame.querySelector('[data-mp-video-toggle]');
    const icon = frame.querySelector('[data-mp-video-icon]');
    const section = frame.closest('.mp-loop-video');
    const shopifySection = frame.closest('.shopify-section');
    const backdrop = section?.querySelector('[data-mp-video-backdrop]');
    const closeButton = frame.querySelector('[data-mp-video-close]');
    if (!video || !button || !icon || !section || !closeButton) return;

    video.pause();
    video.muted = true;
    video.volume = 1;

    const pauseQuietly = () => {
      video.pause();
      video.muted = true;
      sync();
    };

    const playWithSound = () => {
      document.dispatchEvent(new CustomEvent('mp:video-play-request', { detail: { video } }));
      video.muted = false;
      video.volume = 1;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          video.muted = true;
          sync();
        });
      }
      sync();
    };

    const setImmersive = (open) => {
      section.classList.toggle('is-immersive', open);
      shopifySection?.classList.toggle('mp-video-active-section', open);
      document.body.classList.toggle('mp-video-focus', open);
      frame.setAttribute('aria-label', open ? 'Close immersive video' : 'Play video with sound');
      frame.setAttribute('aria-pressed', open ? 'true' : 'false');
    };

    const sync = () => {
      const paused = video.paused || video.muted;
      button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      button.setAttribute('aria-pressed', paused ? 'true' : 'false');
      icon.textContent = paused ? '▶' : 'Ⅱ';
    };

    frame.addEventListener('click', (event) => {
      if (event.target.closest('button')) return;
      if (video.paused || video.muted) playWithSound();
      else pauseQuietly();
    });
    frame.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (video.paused || video.muted) playWithSound();
        else pauseQuietly();
      }
    });
    frame.addEventListener('mouseenter', playWithSound);
    frame.addEventListener('mouseleave', pauseQuietly);
    document.addEventListener('mp:video-play-request', (event) => {
      if (event.detail?.video !== video) pauseQuietly();
    });
    backdrop?.addEventListener('click', () => {
      pauseQuietly();
      setImmersive(false);
    });
    closeButton.addEventListener('click', (event) => {
      event.stopPropagation();
      pauseQuietly();
      setImmersive(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && section.classList.contains('is-immersive')) {
        pauseQuietly();
        setImmersive(false);
      }
    });
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      if (video.paused || video.muted) playWithSound();
      else pauseQuietly();
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dialog = document.currentScript?.previousElementSibling?.matches('dialog') ? document.currentScript.previousElementSibling : document.querySelector('.mp-popup');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const key = 'motionpapa_newsletter_popup';
    const close = () => {
      dialog.close();
      localStorage.setItem(key, String(Date.now()));
    };
    dialog.querySelectorAll('[data-mp-popup-close]').forEach((button) => button.addEventListener('click', close));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    const success = Boolean(dialog.querySelector('[data-mp-popup-success]'));
    if (success) {
      localStorage.setItem(`${key}_subscribed`, 'true');
      dialog.showModal();
      return;
    }
    if (Shopify.designMode) {
      dialog.showModal();
      return;
    }
    if (localStorage.getItem(`${key}_subscribed`) === 'true') return;
    const dismissed = Number(localStorage.getItem(key) || 0);
    const waitDays = Number(dialog.dataset.days || 14) * 86400000;
    if (dismissed && Date.now() - dismissed < waitDays) return;
    window.setTimeout(() => { if (!dialog.open) dialog.showModal(); }, Number(dialog.dataset.delay || 5000));
  })();

  } catch(e) { console.error(e); }
})();
})();
